/**
 * Static-translations for cs. Generated from:
 *  - `online/lang/static-translations.ts` (legacy, via KEY_MAP)
 *  - `tools/sdk-translations.mjs` (SDK-specific strings)
 *
 * Do not edit by hand — changes are lost on the next `node tools/gen-locales.mjs`.
 * To fix a translation, edit legacy/sdk-translations.mjs and regenerate.
 */
const cs = {
  'anon.heading_default': 'Pokračovat jako host',
  'anon.try_again': 'Zkusit znovu',
  'auth.back_to_login': 'Zpět na přihlášení',
  'auth.check_email_message': 'Zkontrolujte e-mail — poslali jsme potvrzovací kód.',
  'auth.check_email_title': 'Zkontrolujte e-mail',
  'auth.confirm_email_title': 'Potvrďte e-mail',
  'auth.confirmation_code': 'Potvrzovací kód',
  'auth.continue_with_apple': 'Pokračovat přes Apple',
  'auth.continue_with_facebook': 'Pokračovat s Facebookem',
  'auth.continue_with_github': 'Pokračovat s GitHub',
  'auth.continue_with_google': 'Pokračovat přes Google',
  'auth.create_account': 'Vytvořit účet',
  'auth.default_subtitle': 'Přihlaste se pro přístup ke všem funkcím a synchronizaci dat.',
  'auth.email': 'E-mailová adresa',
  'auth.email_already_registered': 'Tento e-mail je již zaregistrován. Přihlaste se níže heslem nebo účtem, který jste použili při registraci.',
  'auth.email_exists': 'Účet s tímto e-mailem již existuje.',
  'auth.email_not_confirmed': 'Nejprve potvrďte svůj e-mail.',
  'auth.forgot_password': 'Zapomněli jste heslo?',
  'auth.forgot_password_title': 'Zapomněli jste heslo?',
  'auth.forgot_subtitle': 'Zadejte svůj e-mail a zašleme vám odkaz pro obnovení hesla.',
  'auth.generic_error': 'Něco se pokazilo',
  'auth.have_account': 'Máte účet?',
  'auth.hide_password': 'Skrýt heslo',
  'auth.identity_already_linked': 'Tento účet je již zaregistrován. Přihlaste se jím níže.',
  'auth.invalid_credentials': 'Nesprávný e-mail nebo heslo',
  'auth.invalid_otp': 'Kód je neplatný nebo vypršel.',
  'auth.last_used': 'Naposledy · {email}',
  'auth.last_used_no_email': 'Naposledy',
  'auth.link_purchase_subheading': 'Propojíme nákup s vaším účtem, aby přístup zůstal zachován.',
  'auth.log_in': 'Přihlásit se',
  'auth.log_in_link': 'Přihlásit se',
  'auth.login_continue_purchase': 'Přihlaste se pro pokračování v nákupu',
  'auth.network_error': 'Chyba sítě. Zkontrolujte připojení a zkuste znovu.',
  'auth.no_account': 'Nemáte účet?',
  'auth.or': 'nebo',
  'auth.password': 'Heslo',
  'auth.passwords_mismatch': 'Hesla se neshodují',
  'auth.rate_limited': 'Příliš mnoho požadavků. Zkuste to později.',
  'auth.repeat_password': 'Zopakujte heslo',
  'auth.reset_link_valid': 'Odkaz je platný 1 hodinu.',
  'auth.reset_password_title': 'Resetovat heslo',
  'auth.reset_sent_message': 'Pokud tento e-mail existuje, byl odeslán kód pro reset.',
  'auth.reset_sent_subtitle': 'Poslali jsme odkaz pro obnovení hesla. Postupujte podle pokynů v e-mailu.',
  'auth.restore_purchases_heading': 'Obnovit nákupy',
  'auth.restore_purchases_subheading': 'Přihlaste se pro obnovení svých nákupů.',
  'auth.send_reset': 'Odeslat obnovovací e-mail',
  'auth.service_unavailable': 'Služba je dočasně nedostupná. Zkuste to později.',
  'auth.show_password': 'Zobrazit heslo',
  'auth.sign_out': 'Odhlásit se',
  'auth.sign_up': 'Zaregistrovat se',
  'auth.sign_up_link': 'Zaregistrovat se',
  'auth.signed_in': 'Přihlášen',
  'auth.signin_failed': 'Přihlášení selhalo',
  'auth.signup_failed': 'Registrace selhala',
  'auth.verify': 'Ověřit',
  'auth.weak_password': 'Heslo je příliš slabé.',
  'auth.welcome': 'Vítejte!',
  'auth.welcome_signup': 'Vítejte!',
  'cta.close': 'Zavřít',
  'cta.continue': 'Pokračovat',
  'cta.get_lifetime_access': 'Získat doživotní přístup',
  'cta.get_plan_daily': 'Získat denní plán',
  'cta.get_plan_monthly': 'Získat měsíční plán',
  'cta.get_plan_weekly': 'Získat týdenní plán',
  'cta.get_plan_yearly': 'Získat roční plán',
  'cta.start_trial': 'Začít {days}denní bezplatnou zkušební dobu',
  'modal.close_aria': 'Zavřít',
  'modal.continue': 'Pokračovat',
  'modal.error_generic': 'Něco se pokazilo',
  'modal.loading': 'Načítání…',
  'modal.purchase_restored_subtitle': 'Vše je připraveno — užívejte!',
  'modal.purchase_restored_title': 'Vítejte zpět',
  'modal.purchase_success_subtitle': 'Vše je připraveno — užívejte!',
  'modal.purchase_success_title': 'Platba přijata',
  'modal.verifying_subscription': 'Ověřování předplatného…',
  'nav.back': '← Zpět',
  'nav.back_aria': 'Zpět',
  'offer.limited_time': 'Časově omezená nabídka',
  'payment.awaiting_title': 'Dokončete platbu v nové kartě',
  'payment.checking': 'Ověřování…',
  'payment.ive_paid': 'Zaplatil jsem',
  'payment.open_checkout_again': 'Otevřít platbu znovu',
  'payment.open_checkout_button': 'Otevřít platbu',
  'pricing.free_trial_days': '{days}denní bezplatná zkušební verze',
  'pricing.included_per': 'Zahrnuto za {interval}:',
  'pricing.interval.day': 'den',
  'pricing.interval.lifetime_short': 'navždy',
  'pricing.interval.month': 'měsíc',
  'pricing.interval.period': 'období',
  'pricing.interval.week': 'týden',
  'pricing.interval.year': 'rok',
  'pricing.money_back': '30denní záruka vrácení peněz',
  'pricing.most_popular': 'Nejoblíbenější',
  'pricing.no_prices': 'Žádné ceny nejsou k dispozici.',
  'pricing.plan_label.daily': 'DENNÍ PLÁN',
  'pricing.plan_label.lifetime': 'doživotní',
  'pricing.plan_label.monthly': 'měsíční plán',
  'pricing.plan_label.weekly': 'týdenní plán',
  'pricing.plan_label.yearly': 'roční plán',
  'pricing.plans_aria': 'Plány',
  'session.contact_support': 'Kontaktovat podporu',
  'session.restore_purchases': 'Obnovit nákupy',
  'session.sign_out': 'Odhlásit se',
  'session.signed_in_as_prefix': 'Přihlášen jako',
  'session.signing_out': 'Odhlašování…',
  'support.attachments_label': 'Přílohy',
  'support.close_button': 'Zavřít',
  'support.done_button': 'Hotovo',
  'support.email_placeholder': 'Zadejte svůj e-mail',
  'support.heading': 'Podpora',
  'support.instruction': 'Vyplňte prosím formulář níže pro odeslání žádosti o podporu.',
  'support.invalid_email': 'Neplatný e-mail',
  'support.message_length': '1–5000 znaků',
  'support.message_placeholder': 'Zadejte zprávu',
  'support.required': 'Povinné',
  'support.send_another': 'Odeslat další žádost',
  'support.send_button': 'Odeslat',
  'support.sending': 'Odesílání…',
  'support.subject_length': '3–200 znaků',
  'support.subject_placeholder': 'Zadejte předmět',
  'support.success_heading': 'Žádost odeslána',
  'support.success_message_prefix': 'Obdrželi jsme vaši zprávu a odpovíme na'
} as const;

export default cs;
